import { DateTime } from "luxon";
import { getInteractionParticipantHeading } from "@/components/interactions/_utils";
import { clipTaskDescription } from "@/pages/home/_utils/clipTaskDescription";
import type { RecentInteractionNode } from "@/pages/home/queries";

type InteractionParticipant = RecentInteractionNode["participants"][number];

export function getInteractionRecencyTimestamp(interaction: RecentInteractionNode): string {
  return interaction.createdAt || interaction.interactionDate;
}

export function formatInteractionRecencyLabel(timestamp: string): string | null {
  const parsed = /(?:Z|[+-]\d{2}:\d{2})$/.test(timestamp)
    ? DateTime.fromISO(timestamp, { setZone: true })
    : DateTime.fromISO(timestamp);

  if (!parsed.isValid) {
    return null;
  }

  return parsed.toLocal().toRelative({ base: DateTime.now() });
}

export function getInteractionParticipantLabel(participants: InteractionParticipant[], relatedTo?: string): string {
  return getInteractionParticipantHeading(participants, relatedTo);
}

export function getInteractionInitials(name: string): string {
  const initials = name
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase() ?? "")
    .join("");

  return initials || "IN";
}

export function getPrimaryParticipantPgaId(participants: InteractionParticipant[]): string | null {
  return participants[0]?.pgaId ?? null;
}

export function getInteractionDescription(interaction: RecentInteractionNode): string | undefined {
  const text = interaction.showAiSummary
    ? interaction.summary || interaction.lastMessage.content || ""
    : interaction.lastMessage.content || "";
  return clipTaskDescription(text);
}

export function isAccessibleInteraction(interaction: RecentInteractionNode): boolean {
  const { isPrivate, haveAccess } = interaction.lastMessage;
  return !isPrivate || haveAccess;
}
